var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.path}},[_c('b-icon-chevron-right'),_vm._v(" "),_c('span',{staticClass:"link-title"},[_vm._v(_vm._s(_vm.collapseName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }